export default class WebComponent extends HTMLElement {
  listeners;

  addListener(element, type, listener) {
    this.listeners = this.listeners || [];
    this.listeners.push({ listener, element, type });
    element.addEventListener(type, listener);
  }

  disconnectedCallback() {
    this.listeners.forEach(({ element, type, listener }) => {
      if (element) {
        element.removeEventListener(type, listener);
      }
    });
  }
}
